import { HStack, Icon, Spacer, Text } from '@chakra-ui/react';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS, TRACKING_PAGES } from '@diamond/sol-buyer/constant';
import { ChevronRightOutlined } from '@mui/icons-material';
import Link from 'next/link';

import { Image } from '../../common';

type RecipeCountProps = {
  count: number;
  name: string;
  productId: string;
  itemCode?: string;
  brandName?: string;
};

export function RecipeCount({
  count,
  productId,
  name = '',
  itemCode,
  brandName,
}: RecipeCountProps) {
  if (!count) return null;

  return (
    <Link
      href={`/recipes?q=${name}`}
      onClick={() =>
        trackEvent(TRACKING_EVENTS.CLICK_PRODUCT_TO_RECIPE, {
          id_product: productId,
          name: name,
          section_name: TRACKING_PAGES.PRODUCT_DETAIL,
          item_id: itemCode ?? productId,
          item_name: name,
          item_brand: brandName ?? '',
        })
      }
    >
      <HStack
        position="relative"
        bg="#CEF0FF"
        borderColor="#A1D1FF"
        borderWidth="1px"
        px="1"
        py="2"
        rounded="full"
        shadow="md"
      >
        <Image
          src="/images/recipe-count.png"
          alt="recipe count"
          width={64}
          height={64}
          quality={100}
          style={{
            position: 'absolute',
            left: '-1rem',
          }}
        />
        <Spacer flex="0 0 1.5rem" />
        <Text flex="1" textAlign="center" fontSize="xs" color="#00003D">
          <strong>Lihat {count} Inspirasi resep </strong> dari produk ini
        </Text>
        <Icon fontSize="md" color="#00003D" as={ChevronRightOutlined} />
      </HStack>
    </Link>
  );
}
